module.exports = __webpack_public_path__ + "img/trash.064fd194.svg";